import React, { Component } from 'react';

import { inject } from 'mobx-react';
import { Box, Flex, Card, Heading, Button, Text } from 'core/components';

import ContactAccountTeamDialog from 'app/views/licenses/ContactAccountTeamDialog';
import LargeLabeledValue from 'app/components/LargeLabeledValue';

@inject('$companySettings')
export default class AccountTeamCard extends Component {
  state = {
    accountTeam: [],
    contactMember: undefined,
    hoveredAccountMember: null,
    isContactDialogOpen: false
  };

  static defaultProps = {
    showContact: true
  };

  static getDerivedStateFromProps(props) {
    if (props.accountTeam) {
      return { accountTeam: props.accountTeam };
    }
    return null;
  }

  componentDidMount() {
    const { $companySettings } = this.props;
    const { accountTeam: stateAccountTeam } = this.state;
    if (!stateAccountTeam?.length) {
      $companySettings.fetchAccountTeam().then((accountTeam) => {
        this.setState({ accountTeam });
      });
    }
  }

  onContactAccountTeamClick = ({ contactMember }) => {
    this.setState({ isContactDialogOpen: true, contactMember });
  };

  onContactAccountTeamClose = () => {
    this.setState({ isContactDialogOpen: false });
  };

  onAccountMemberMouseOver = (hoveredAccountMember) => {
    this.setState({ hoveredAccountMember });
  };

  getRoleLabel(role) {
    switch (role) {
      case 'AE':
        return 'Account Executive';
      case 'SE':
        return 'Solutions Engineer';
      case 'CSE':
        return 'Customer Success Engineer';
      case 'CSM':
        return 'Customer Success Manager';
      default:
        return role;
    }
  }

  render() {
    const { showContact, isBlock } = this.props;
    const { isContactDialogOpen, accountTeam, hoveredAccountMember, contactMember } = this.state;

    if (accountTeam.length) {
      return (
        <Box mb={3}>
          <Heading level={4}>Account Team</Heading>
          <Card p={2}>
            <Flex flexDirection={isBlock ? 'row' : 'column'} justifyContent="space-between" alignItems="center">
              <div>
                {accountTeam.map((member, idx) => {
                  if (showContact) {
                    return (
                      <Button
                        key={member.user_email}
                        textAlign="left"
                        minimal
                        fill
                        onClick={() => this.onContactAccountTeamClick({ contactMember: member })}
                        onMouseOver={() => this.onAccountMemberMouseOver(member)}
                        onMouseOut={this.onAccountMemberMouseOver}
                        rightIcon={hoveredAccountMember === member && 'envelope'}
                      >
                        <Flex>
                          <Box>
                            <Text as="span" fontWeight="bold">
                              {this.getRoleLabel(member.user_role)}:{' '}
                            </Text>
                            <Text as="span">{member.user.user_full_name}</Text>
                          </Box>
                        </Flex>
                      </Button>
                    );
                  }

                  return (
                    <LargeLabeledValue
                      key={member.user_email}
                      label={this.getRoleLabel(member.user_role)}
                      value={member.user.user_full_name}
                      shouldFormatValue={false}
                      mb={idx === accountTeam.length - 1 ? 0 : 1}
                    />
                  );
                })}
              </div>

              {showContact && (
                <Flex alignSelf="start" p="4px">
                  <Button fill intent="primary" text="Contact Account Team" onClick={this.onContactAccountTeamClick} />
                </Flex>
              )}
            </Flex>
          </Card>
          {isContactDialogOpen && (
            <ContactAccountTeamDialog
              isOpen={isContactDialogOpen}
              contactMember={contactMember}
              onClose={this.onContactAccountTeamClose}
            />
          )}
        </Box>
      );
    }
    return null;
  }
}
